module.exports = __webpack_public_path__ + "static/media/fargo-logo-circle.16942c8b.png";